import {
  ConnectionError,
  NotFoundError,
  ServiceUnavailableError,
  UnauthorizedAccessError
} from '../app/errors';
import { SlipConflictError, SlipUnsupportedShopError } from '../slip/errors';
import OneOfSlipsNotFoundError from './errors';

export const constructBetslipUrl = (slipIds) => (
  `${api_config.bet_tracker_api}/bet/slips/${slipIds.join(',')}/?sortOrder=off`
);

export const constructAccountBetsUrl = (
  dateFrom = null,
  dateTo = null,
  showActiveSlips = null,
  nextSlip = null
) => {
  let queryString = 'sortOrder=off';
  if (dateFrom instanceof Date && dateTo instanceof Date) {
    queryString += `&dateTimeFrom=${dateFrom.toISOString()}&dateTimeTo=${dateTo.toISOString()}`;
  }
  if (showActiveSlips === false) {
    queryString += '&showActiveSlips=false';
  }
  if (nextSlip !== null) {
    queryString += `&nextSlip=${nextSlip}`;
  }
  return `${api_config.bet_tracker_api}/bets/?${queryString}`;
};

export const getBets = (slipIds, userAuthenticated = false) => (
  fetch(constructBetslipUrl(slipIds), {
    method: 'GET',
    credentials: (userAuthenticated) ? 'include' : 'omit',
    cache: 'no-cache'
  })
    .catch(e => {
      throw new ConnectionError(e.message);
    })
    .then(response => {
      const { status, statusText } = response;

      switch (status) {
        case 200: {
          return response;
        }
        case 303: {
          throw new OneOfSlipsNotFoundError(statusText, status);
        }
        case 400:
        case 404: {
          throw new NotFoundError(statusText, status);
        }
        case 401: {
          throw new UnauthorizedAccessError(statusText, status);
        }
        case 409: {
          throw new SlipConflictError(statusText, status);
        }
        case 418: {
          throw new SlipUnsupportedShopError(statusText, status);
        }
        case 520: {
          throw new ServiceUnavailableError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
    .then(response => ((response.status === 200) ? response.json() : response))
);

/* eslint-disable no-unused-vars */
export const getAccountBets = (
  dateFrom = null,
  dateTo = null,
  showActiveSlips = null,
  nextSlip = null
) => (
  fetch(constructAccountBetsUrl(dateFrom, dateTo, showActiveSlips, nextSlip), {
    method: 'GET',
    credentials: 'include',
    cache: 'no-cache'
  })
    .catch(e => {
      throw new ConnectionError(e.message);
    })
    .then(response => {
      const { status, statusText } = response;

      switch (status) {
        case 200: {
          return response;
        }
        case 403: {
          throw new UnauthorizedAccessError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
    .then(response => ((response.status === 200) ? response.json() : response))
);

export function getBet(betId, userAuthenticated, slip) {
  return getBets([slip], userAuthenticated)
    .then(results => results.bets.find(b => b.betId === betId));
}
